import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormFieldErrorMessageComponent } from '@gelato-api-ui/sdk/src/lib/shared/form-field-error-message/form-field-error-message.component';
import { CheckboxComponent } from '@gelato-api-ui/ui-kit/src/lib/components/checkbox/checkbox.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'ui-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, CheckboxComponent, FormFieldErrorMessageComponent, TranslateModule],
})
export class TermsAndConditionsComponent {
  @Input() termsAndConditionsChecked: boolean;
  @Input() receiveNewsChecked: boolean;
  @Input() termsAndConditionsError: boolean;

  @Output() termsAndConditionsChange = new EventEmitter<boolean>();
  @Output() receiveNewsChange = new EventEmitter<boolean>();

  get hasError() {
    return !!this.termsAndConditionsError;
  }

  onClickTerms(termsAndConditions: boolean) {
    this.termsAndConditionsChange.emit(termsAndConditions);
  }

  onClickReceiveNews(receiveNews: boolean) {
    this.receiveNewsChange.emit(receiveNews);
  }
}
